<cxone-modal #modal class="cxone-modal history-modal custom-modal-padding" [headerTitle]="headerTitle" [allowClose]="allowClose"
    [saveLabel]="saveLabel"
    (dismissed)="onDismiss()" (closed)="onClose()">
    <ag-grid-angular
        *ngIf="gridOptions"
        [gridOptions]="gridOptions"
        class="sol-grid ag-theme-balham flex-fill border-0 d-block w-100 h-100"
    ></ag-grid-angular>
</cxone-modal>